import {RoutesList as Rf} from "./RoutesList";
import {ReactElement} from "react";
import {Dashboard} from "../pages/Dashboard";
import {Analytics} from "../pages/Analytics";
import {Details} from "../pages/Details";
import {Login} from "../components/Login";
import {SignUp} from "../components/SignUp";
import {NotFound} from "../components/NotFound";
import {Users} from "../pages/Users";
import {AllReadings} from "../pages/Allreadings";
import {AllDevices} from "../pages/AllDevices";
import {AllAdmins} from "../pages/superAdmin/AllAdmins";
import roles from "./roles";
import {MyDevices} from "../pages/MyDevices";
import {AllClients} from "../pages/supremeAdmin/AllClients";

interface routes{
    path : string,
    component : ReactElement,
    roles : string[]
}


const routes : routes[] = [

    {
        path : Rf.Dashboard.Path,
        component : <Dashboard />,
        roles : [roles.user]
    },
    {
        path : Rf.Analytics.path,
        component: <Analytics/>,
        roles: [roles.user]
    },
    {
        path : Rf.MyDevices.path,
        component: <MyDevices/>,
        roles: [roles.user]
    },
    {
        path : Rf.Details.path,
        component : <Details/>,
        roles : [roles.user,roles.superAdmin,roles.admin]
    },
    // {
    //     path : Rf.Login.path,
    //     component : <Login/>
    // },
    // {
    //     path : Rf.SignUp.path,
    //     component : <SignUp />
    // },
    {
        path : Rf.UsersList.path,
        component : <Users />,
        roles : [roles.admin,roles.superAdmin]
    },
    {
        path : Rf.AllReadings.path,
        component : <AllReadings />,
        roles : [roles.superAdmin]
    },
    {
        path : Rf.AllDevices.path,
        component : <AllDevices />,
        roles : [roles.superAdmin]
    },
    {
        path : Rf.DeviceDetail.path,
        component : <AllReadings />,
        roles : [roles.superAdmin]
    },
    {
        path: Rf.AdminsList.path,
        component : <AllAdmins />,
        roles : [roles.superAdmin]
    },
    {
        path: Rf.AllClients.path,
        component : <AllClients />,
        roles : [roles.supremeAdmin]
    }
    // {
    //     path : "*",
    //     component : <NotFound/>
    // }
]

export default routes